"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpokenLanguageSchema = void 0;
const zod_1 = require("zod");
const language_1 = require("./language");
const language_level_1 = require("./language-level");
exports.SpokenLanguageSchema = zod_1.z.object({
  language_id: zod_1.z.coerce.number(),
  language: language_1.LanguageSchema.optional(),
  level_id: zod_1.z.coerce.number(),
  level: language_level_1.LanguageLevelSchema.optional()
});
